// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"812":"8421dd8b","967":"8421dd8b"}[chunkId] + ".chunk.css";
};